__turbopack_context__.v({
  "capitalize": "OrderTimeSelectionStep-module-scss-module__YFzUHW__capitalize",
  "dayRow": "OrderTimeSelectionStep-module-scss-module__YFzUHW__dayRow",
  "modalBody": "OrderTimeSelectionStep-module-scss-module__YFzUHW__modalBody",
  "modalFooter": "OrderTimeSelectionStep-module-scss-module__YFzUHW__modalFooter",
  "noPadding": "OrderTimeSelectionStep-module-scss-module__YFzUHW__noPadding",
  "pickerTime": "OrderTimeSelectionStep-module-scss-module__YFzUHW__pickerTime",
  "pickerTimeRow": "OrderTimeSelectionStep-module-scss-module__YFzUHW__pickerTimeRow",
  "pickerTimeSection": "OrderTimeSelectionStep-module-scss-module__YFzUHW__pickerTimeSection",
  "selectable": "OrderTimeSelectionStep-module-scss-module__YFzUHW__selectable",
  "selected": "OrderTimeSelectionStep-module-scss-module__YFzUHW__selected",
});
